<empathy-viewer-card [fullSize]="true" [noTitle]="true">
  <div slot="content">
    <div #carouselSwipeContainer class="carousel-view__container" [class.is-phone]="isPhone$ | async">
      <div class="carousel-view__container__actions">
        <button [title]="'system.carousel.moveToPreviousCard' | translate" class="prev-btn" [disabled]="activeCard$() === 0" (click)="onPrev()">
          <fa-icon [icon]="faChevronLeft"></fa-icon>
        </button>

        <empathy-viewer-progress-bar [color]="'primary'" [progress]="activeCard$() | progress: visibleCards$().length"></empathy-viewer-progress-bar>

        @if (activeCard$() < visibleCards$().length - 1) {
          <button
            [title]="'system.carousel.moveToNextCard' | translate"
            class="next-btn"
            [disabled]="!questionsGrp().get(visibleCards$()[activeCard$()].id).value"
            (click)="onNext()"
          >
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        }
      </div>

      <div [@trigState]="activeCard$()" class="carousel-view__container__question">
        <div [id]="visibleCards$()[activeCard$()].id" class="carousel-view__container__question__title fs__xxxl fw__500">
          @if (!!visibleCards$()[activeCard$()].stimulus?.mediaId) {
            <empathy-option-media
              [media]="visibleCards$()[activeCard$()].stimulus"
              [altText]="visibleCards$()[activeCard$()].text"
              [align]="'center'"
              [noBorder]="true"
            >
              <span class="fs__xxxl fw__500" [innerHTML]="visibleCards$()[activeCard$()].text | translate"></span>
            </empathy-option-media>
          } @else {
            <span class="fs__xxxl fw__500" [innerHTML]="visibleCards$()[activeCard$()].text | translate"></span>
          }
        </div>

        @if (activeCard$() < visibleCards$().length - 1) {
          @for (cardQuestion of questionsGrp().value | keyvalue; track cardQuestion.key) {
            @switch (question().ratingType) {
              @case (ratingType.numeric) {
                <div
                  [@staggerRating]="cardQuestion.key === visibleCards$()[activeCard$()].id"
                  [class.active]="cardQuestion.key === visibleCards$()[activeCard$()].id"
                  class="carousel-view__container__question__scale-container"
                  ratingsPosition
                  [scale]="question().ratingScale"
                >
                  <mat-button-toggle-group
                    name="rating"
                    hideSingleSelectionIndicator
                    [disabled]="movingToNextCard$()"
                    [vertical]="question().ratingScale > maxXRatingScale"
                  >
                    @for (scale of [].constructor(question().ratingScale); track scale; let index = $index) {
                      <mat-button-toggle
                        [value]="index + 1"
                        [checked]="getQuestionGroupForm(cardQuestion.key).value === index + 1"
                        (click)="onRateAndMoveToNextCard(cardQuestion.key, index + 1)"
                      >
                        <span class="fs__md">{{ index + 1 }}</span>
                      </mat-button-toggle>
                    }
                  </mat-button-toggle-group>

                  <div class="carousel-view__container__question__scale-label">
                    <span class="sub-label fs__md">{{ question().minValueText }}</span>
                    <span class="sub-label fs__md">{{ question().maxValueText }}</span>
                  </div>
                </div>
              }
              @case (ratingType.descriptive) {
                <mat-radio-group
                  [@stagger]="cardQuestion.key === visibleCards$()[activeCard$()].id"
                  [class.active]="cardQuestion.key === visibleCards$()[activeCard$()].id"
                  [disabled]="movingToNextCard$()"
                  color="primary"
                  class="carousel-view__container__question__choices"
                  [attr.aria-labelledby]="cardQuestion.key"
                  (change)="onMoveToNextCard(cardQuestion.key, $event)"
                >
                  @for (option of visibleOptions$(); track activeCard$()) {
                    <mat-radio-button
                      [disableRipple]="true"
                      [value]="option.value"
                      [checked]="option.value === getQuestionGroupForm(cardQuestion.key).value"
                      surveyAutoFocus
                      [animationDelay]="300"
                      [condition]="option.value === getQuestionGroupForm(cardQuestion.key).value"
                    >
                      <div class="survey-viewer__html-content fs__md" [innerHTML]="option.text"></div>
                    </mat-radio-button>
                  }
                </mat-radio-group>
              }
              @case (ratingType.stars) {
                <div
                  #starContainer
                  [@staggerRating]="cardQuestion.key === visibleCards$()[activeCard$()].id"
                  [class.active]="cardQuestion.key === visibleCards$()[activeCard$()].id"
                  class="rating-view__stars-container"
                  ratingsPosition
                  [scale]="question().ratingScale"
                  [maxXRatingScale]="maxXStarsRatingScale$()"
                >
                  <mat-button-toggle-group
                    name="stars"
                    hideSingleSelectionIndicator
                    [ngClass]="applyStarsContainerMaxWidth$() ? 'stars-container-max-width' : ''"
                    [disabled]="movingToNextCard$()"
                    [vertical]="question().ratingScale > maxXStarsRatingScale$()"
                  >
                    @for (scale of [].constructor(question().ratingScale); track scale; let index = $index) {
                      <mat-button-toggle [value]="index + 1" (click)="onRateAndMoveToNextCard(cardQuestion.key, index + 1)">
                        <fa-icon [class.highlighted]="getQuestionGroupForm(cardQuestion.key).value > index" [icon]="faStar"></fa-icon>
                      </mat-button-toggle>
                    }
                  </mat-button-toggle-group>

                  <div class="rating-view__scale-label" [ngClass]="applyStarsContainerMaxWidth$() ? 'stars-container-max-width' : ''">
                    <span class="sub-label fs__sm">{{ question().minValueText }}</span>
                    <span class="sub-label fs__sm">{{ question().maxValueText }}</span>
                  </div>
                </div>
              }
            }
          }
        }
      </div>
    </div>
  </div>
</empathy-viewer-card>
